import React from 'react'
import {
  Box,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Typography
} from '@mui/material'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/free-solid-svg-icons'
import styles from '../CallAvailabilityView.module.scss'

const TIMEZONES = [
  { value: 'America/New_York', label: 'Eastern Time (ET)' },
  { value: 'America/Chicago', label: 'Central Time (CT)' },
  { value: 'America/Denver', label: 'Mountain Time (MT)' },
  { value: 'America/Los_Angeles', label: 'Pacific Time (PT)' },
  { value: 'America/Phoenix', label: 'Arizona Time (AZ)' },
  { value: 'Pacific/Honolulu', label: 'Hawaii Time (HT)' },
  { value: 'America/Anchorage', label: 'Alaska Time (AKT)' },
  { value: 'UTC', label: 'UTC' }
]

const WorkHoursTimePicker = ({ workHours, onChange }) => {
  const handleTimeChange = (field, value) => {
    onChange({
      ...workHours,
      [field]: value
    })
  }

  const handleTimezoneChange = (event) => {
    onChange({
      ...workHours,
      timezone: event.target.value
    })
  }

  return (
    <Box className={styles.workHoursTimePicker}>
      <Box className={styles.timeSection}>
        <Box className={styles.timeInputGroup}>
          <TextField
            label='Start Time'
            type='time'
            value={workHours.start}
            onChange={(e) => handleTimeChange('start', e.target.value)}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              step: 300
            }}
            className={styles.timeInput}
          />

          <Box className={styles.timeArrow}>
            <FontAwesomeIcon icon={faArrowRight} />
          </Box>

          <TextField
            label='End Time'
            type='time'
            value={workHours.end}
            onChange={(e) => handleTimeChange('end', e.target.value)}
            InputLabelProps={{
              shrink: true
            }}
            inputProps={{
              step: 300
            }}
            className={styles.timeInput}
          />
        </Box>

        <Box className={styles.workHoursSummary}>
          <Typography variant='body2' className={styles.summaryText}>
            {calculateWorkHours(workHours.start, workHours.end)} hours per day
          </Typography>
        </Box>
      </Box>

      <Box className={styles.timezoneSection}>
        <FormControl className={styles.timezoneSelect}>
          <InputLabel id='timezone-label'>Timezone</InputLabel>
          <Select
            labelId='timezone-label'
            value={workHours.timezone || 'America/New_York'}
            onChange={handleTimezoneChange}
            label='Timezone'
          >
            {TIMEZONES.map((tz) => (
              <MenuItem key={tz.value} value={tz.value}>
                {tz.label}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
    </Box>
  )
}

function calculateWorkHours(start, end) {
  const [startHour, startMin] = start.split(':').map(Number)
  const [endHour, endMin] = end.split(':').map(Number)

  const startMinutes = startHour * 60 + startMin
  const endMinutes = endHour * 60 + endMin

  const totalMinutes = endMinutes - startMinutes
  const hours = Math.floor(totalMinutes / 60)
  const minutes = totalMinutes % 60

  if (minutes === 0) {
    return hours
  } else {
    return `${hours}.${minutes < 10 ? '0' : ''}${minutes}`
  }
}

export default WorkHoursTimePicker
